import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

import axios from 'axios';
import Header from '../Appointment/components/Header/Header';
import SearchBar from '../../components/SearchBar/SearchBar';
import TableList from './components/TableList/TableList';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3),
        
    },

    results: {
        marginTop: theme.spacing(3)
    }
    
}));

export default function Appointment() {

    const classes = useStyles();

    const handleFilter = () => { };
    const handleSearch = () => { };

    return (
        <React.Fragment className={classes.root}>
            <Grid container spacing={0}>
                <Grid item xs={12} >
                    <div
                        // className={classes.root}
                        // style={{padding: '1rem'}}
                        // classes={classes}
                        title="Appointment Details"
                    >
                        <Header />
                        {/* <SearchBar
                    onSearch={handleSearch}
                /> */}
                        <TableList
                            classes={classes}
                            className={classes.results}
                        />
                    </div>
                </Grid>
            </Grid>
            
        </React.Fragment>
           
            
        
            

    )
}